import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OrderApiModel } from '../model/api-model/order/order.api.model';
import { ScreeningItemApiModel } from '../model/api-model/order/screening-item/screening-item.api.model';
import { OrderHttpService } from './order.http.service';

@Injectable({
  providedIn: 'root'
})
export class OrderItemHttpService {
  constructor(private http: HttpClient) {}

  patchScreeningItem(cinemaId: string, orderId: string, items: ScreeningItemApiModel[]): Observable<OrderApiModel> {
    const payload = this.createPatchPayload(items);

    return this.http
      .patch<OrderApiModel>(`/cinema/${cinemaId}/order/${orderId}/screeningitem`, payload)
      .pipe(tap((res) => OrderItemHttpService.cacheModify(orderId, res)));
  }

  deleteScreeningItem(cinemaId: string, orderId: string, id: string): Observable<OrderApiModel> {
    return this.http
      .delete<OrderApiModel>(`/cinema/${cinemaId}/order/${orderId}/screeningitem/${id}`)
      .pipe(tap((res) => OrderItemHttpService.cacheModify(orderId, res)));
  }

  private static cacheModify(key: string, responseData: Object): void {
    OrderHttpService.cacheModifier$.next((data: any[]) => {
      const oldCacheRow = data.find((p) => p.parameters[1] === key);
      if (!oldCacheRow) {
        return;
      }

      Object.assign(oldCacheRow.response, {
        ...responseData
      });

      return data;
    });
  }

  private createPatchPayload(items: ScreeningItemApiModel[]): ScreeningItemApiModel[] {
    return (items ?? []).map((item) => {
      const model = new ScreeningItemApiModel();
      model.id = item?.id;
      model.seatId = item?.seatId;
      model.screeningId = item?.screeningId;
      model.ticketId = item?.ticketId;
      model.quantity = item?.quantity;
      model.extraFees = item?.extraFees ?? [];
      model.optionalExtraFees = item?.optionalExtraFees ?? [];

      return model;
    });
  }
}
